import {
	AfterViewInit,
	ChangeDetectorRef,
	Component,
	ElementRef,
	EventEmitter,
	HostListener,
	Input,
	OnChanges,
	OnInit,
	Output,
	SimpleChanges,
	TemplateRef,
	ViewChild
} from '@angular/core';
import { CalendarEvent, CalendarView } from 'angular-calendar';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import {
	MISSION_TYPE_REUNION_TYPE,
	PARAM_LABEL_INTERVENANT,
	PARAM_LABEL_INTERVENTION
} from 'src/app/core/services/constant/constants.service';
import { FacadeService } from 'src/app/core/services/facade.service';
import { LogService } from 'src/app/core/services/log/log.service';
import { saveAs } from 'file-saver';
import { Employee } from 'src/app/shared/models/employee/employee';
import { Solution } from 'src/app/shared/models/solution';
import { User } from 'src/app/shared/models/security/user';
import { DateUtils } from 'src/app/shared/utils/date-utils';
import { ExportPdfUtils } from 'src/app/shared/utils/export-pdf-utils';
import { Authority } from 'src/app/shared/models/security/authority';
import { Beneficiaire } from 'src/app/shared/models/beneficiaire';
import { ErrorResponse } from 'src/app/shared/models/api-response/error-response';
import {
	CriteriaReport,
	OptimizationReport
} from 'src/app/shared/models/optimization-report';
import { ReportLabelEnum } from 'src/app/shared/enums/report-label-enum';
import { MOptimReport } from 'src/app/shared/models/m-optim-report';
import { MissionType } from 'src/app/shared/models/mission/mission-type';
import { ServiceCenter } from 'src/app/shared/models/service-center';
import { MissionPlace } from 'src/app/shared/models/mission/mission-place';
import { CareSkill } from 'src/app/shared/models/employee/care-skill';
import { CenterDepartment } from 'src/app/shared/models/center-department';

export type SortOrder = 'asc' | 'desc';
@Component({
	selector: 'app-navbar-planning',
	templateUrl: './navbar-planning.component.html',
	styleUrls: ['./navbar-planning.component.scss']
})
export class NavbarPlanningComponent
	implements OnInit, AfterViewInit, OnChanges
{
	@Input() employeesList: Employee[] = [];
	@Input() listMissionTypes: MissionType[] = [];
	@Input() listMissionPlaces: MissionPlace[] = [];
	@Input() listCenterDepartments: CenterDepartment[] = [];
	@Input() solution: Solution;
	@Input() solutions: Solution[];
	@Input() view: CalendarView;
	@Input() beginDate: Date;
	@Input() endDate: Date;
	@Input() selectedCalendarDate: Date;
	@Input() selectedWeek: number;
	selectedYear: number;
	@Input() isModeListActive: any;
	@Input() isModeAvailabilityActive: any;
	@Input() isActionsAllowed: boolean;
	@Input() isLoadingSolution: boolean;
	@Input() canDisplayAvailabilityPlanning: boolean;
	@Input() eventAvailabilitySaved: CalendarEvent[];
	@Input() competences;
	@Input() listBeneficiaires: Beneficiaire[];
	@Input() listViewableCenters: { id: number; name: string; type: number }[] =
		[];
	@Input() selectedCenter: { id: number; name: string; type: number } = null;

	@Output() setAlignedView: EventEmitter<any> = new EventEmitter();
	@Output() launchBuild: EventEmitter<any> = new EventEmitter();
	@Output() getDataForPlanning: EventEmitter<any> = new EventEmitter();
	@Output() setView: EventEmitter<any> = new EventEmitter();
	@Output() changeHourSegments: EventEmitter<any> = new EventEmitter();
	@Output() addOrRemoveDay: EventEmitter<any> = new EventEmitter();
	@Output() refreshView: EventEmitter<any> = new EventEmitter();
	@Output() selectedCenterChangeEvent: EventEmitter<any> = new EventEmitter();
	@Output() openCreateVacationModaleEmitter: EventEmitter<any> =
		new EventEmitter();

	@ViewChild('prev') prev: ElementRef;
	@ViewChild('next') next: ElementRef;

	@ViewChild('validatePlanningModal', { static: true })
	templateVerouillage: TemplateRef<any>;
	@ViewChild('tmpOptimReportsModal', { static: true })
	tmpOptimReportsModal: TemplateRef<any>;
	@ViewChild('copyingDataModal', { static: true })
	copyingDataModal: TemplateRef<any>;
	@ViewChild('exportCalendarModal', { static: true })
	templateExportCalendarModal: TemplateRef<any>;
	@ViewChild('solutionNotesModal', { static: true })
	templateSolutionNotes: TemplateRef<any>;

	modalRefDeverouillage?: BsModalRef;
	modalRefVerouillage?: BsModalRef;
	modalRefOptimizationReport?: BsModalRef;
	modalRefTmpOptimReports?: BsModalRef;
	modalRefSolutionNotes?: BsModalRef;
	templateCopyingData?: BsModalRef;
	modalRefExportCalendar?: BsModalRef;

	Authority = Authority;

	defaultText = 'Tous';
	ddEmployee: string = null;
	ddBeneficiaire: string = null;
	CalendarView = CalendarView;

	isPreviousActive = true;
	isNextActive = true;

	isAbsenceSwitchActive = false;
	isWeekendActive = false;
	isViewTourneesSwitchActive = true;
	isAlignedWeekViewSwitchActive = true;
	isScheduledViewUnassignedMissionsSwitchActive = true;
	isScheduledViewAllEmpsSwitchActive = false;
	isSolutionNotesEditing = false;

	textareaLineCount = 10;

	currentUser: User = null;
	currentUserCenter: ServiceCenter;
	currentUserAuthority: number = null;
	currentLoggedInEmployeeId: number = null;

	labelIntervenantCapitalizedPluralized: string;
	labelIntervention: string;
	labelInterventionCapitalized: string;

	monthsFr = [
		'janv',
		'févr',
		'mars',
		'avr',
		'mai',
		'juin',
		'juill',
		'aout',
		'sept',
		'oct',
		'nov',
		'déc'
	];
	daysFr = [
		'Dimanche',
		'Lundi',
		'Mardi',
		'Mercredi',
		'Jeudi',
		'Vendredi',
		'Samedi'
	];

	// Interceptor pour le "close" de la modale (ngx bootstrap)
	confirmResolve?: () => void;
	confirmReject?: () => void;
	confirmPromise?: Promise<void>;

	redirectedSolution?: Solution;

	isMobile = false;

	isSESSAD = false;
	isSAAD = false;
	isSSIAD = false;

	today: Date = new Date();
	weekNumberSelectedForCopy: number =
		this.dateUtils.getWeekNumber(this.today) + 1;
	selectedYearNumberForCopy: number = new Date().getFullYear();

	copyButtonDisabled = false;

	// L'employé dont on veut voir le planning (celui sélectionné dans le dropdown)
	selectedEmployeeInDropdown: Employee = null;
	selectedCompetenceInDropdown: any = null;
	selectedBeneficiaireInFilter: Beneficiaire = null;
	isAggregationNecessaryForDropdown: boolean = true;

	optimReport: OptimizationReport = null;
	reportLabelEnum = ReportLabelEnum;
	tmpOptimReports: MOptimReport[];
	displayedCriteriaReport: CriteriaReport[];
	// Label par défaut du bouton
	displayAdditionalInfoButtonLabel =
		'Afficher les informations complémentaires';
	// Label suivant si le bouton a été cliqué ou non
	displayAdditionalInfoButtonLabelInactive =
		'Afficher les informations complémentaires';
	displayAdditionalInfoButtonLabelActive =
		'Cacher les informations complémentaires';
	isDisplayMoreInfoButtonClicked: boolean;

	/**
	 * Attribut sur lequel trier
	 */
	sortType = '';

	/**
	 * Ordre de tri
	 */
	sortOrder: SortOrder = 'asc';

	isPlanificatrice: boolean = false;
	isIntervenant: boolean = false;

	selectedMissionType: MissionType = null;
	ddFormation: string;

	selectedMissionPlace: MissionPlace = null;
	ddMissionPlace: string;

	selectedCenterDepartment: CenterDepartment = null;
	ddCenterDepartment: string;

	isDisabledReportButton: boolean = true;

	constructor(
		private logger: LogService,
		protected exportPdfUtils: ExportPdfUtils,
		private facade: FacadeService,
		public dateUtils: DateUtils,
		private modalService: BsModalService,
		public cdr: ChangeDetectorRef
	) {}

	/**
	 * On récupère l'optimisation report ici, car "@Input() solution" arrive avec un décalage => on ne l'a pas dès le ngOnInit
	 * => on a pas l'id de la solution dès le ngOnInit
	 * @param changes
	 */
	ngOnChanges(changes: SimpleChanges): void {
		if (changes.solution?.currentValue) {
			this.facade.solutionService
				.getOptimizationReport(this.solution.id)
				.subscribe({
					next: (optimReport: OptimizationReport) => {
						this.optimReport = optimReport;
						this.isDisabledReportButton = false;

						this.optimReport.criteriaReports =
							this.optimReport.criteriaReports.sort(
								(crit1, crit2) => crit2.weight - crit1.weight
							);
						// On affiche que les plus importants par défaut
						this.displayedCriteriaReport =
							this.optimReport.criteriaReports.filter((criteriaReport) => {
								return (
									criteriaReport.weight > 0 &&
									criteriaReport.label !== 'AVG_TW_LATE_ARRIVAL_TIME'
								);
							});

						this.cdr.markForCheck();
					},
					error: (err) => {
						this.logger.error('Pas de rapport trouvé pour cette semaine.');
					}
				});
		}
	}

	ngOnInit(): void {
		this.ddEmployee = this.defaultText;
		this.ddBeneficiaire = this.defaultText;
		this.ddFormation = this.defaultText;
		this.ddMissionPlace = this.defaultText;
		this.ddCenterDepartment = this.defaultText;

		this.isPlanificatrice = this.facade.dataStorageService.isPlanificatrice();
		this.isIntervenant = this.facade.dataStorageService.isIntervenant();

		this.isMobile =
			this.facade.mobileService.isMobile() || window.innerWidth < 1000;
		this.labelIntervenantCapitalizedPluralized =
			this.facade.dataStorageService.getLabelCapitalizedPluralized(
				PARAM_LABEL_INTERVENANT
			);
		this.labelIntervention = this.facade.dataStorageService.getLabel(
			PARAM_LABEL_INTERVENTION
		);
		this.labelInterventionCapitalized =
			this.facade.dataStorageService.getLabelCapitalized(
				PARAM_LABEL_INTERVENTION
			);

		this.isSESSAD = this.facade.dataStorageService.isSESSAD();
		this.isSAAD = this.facade.dataStorageService.isSAAD();
		this.isSSIAD = this.facade.dataStorageService.isSSIAD();

		this.currentUser = this.facade.dataStorageService.getUser();
		this.currentUserCenter =
			this.facade.dataStorageService.getUser().employee.serviceCenter;
		this.currentUserAuthority = this.currentUser?.role.id;

		this.currentLoggedInEmployeeId = this.currentUser.employee.id;

		if (this.facade.dataStorageService.getParam('storedCalendarWeeknumber')) {
			this.selectedWeek = this.facade.dataStorageService.getParam(
				'storedCalendarWeeknumber'
			) as number;
		}
		if (this.facade.dataStorageService.getParam('storedCalendarYearnumber')) {
			this.selectedYear = this.facade.dataStorageService.getParam(
				'storedCalendarYearnumber'
			) as number;
		} else {
			this.selectedYear = new Date().getFullYear();
		}

		if (this.facade.dataStorageService.getParam('storedAbsenceSwitchActive')) {
			this.isAbsenceSwitchActive = this.facade.dataStorageService.getParam(
				'storedAbsenceSwitchActive'
			) as boolean;
		} else if (this.currentUserAuthority === Authority.PLANIFICATEUR) {
			this.isAbsenceSwitchActive = true;
		}

		if (
			this.facade.dataStorageService.getParam('storedViewMissionSwitchActive')
		) {
			this.isViewTourneesSwitchActive = this.facade.dataStorageService.getParam(
				'storedViewMissionSwitchActive'
			) as boolean;
		}

		this.updateBeginAndEndDates(
			this.dateUtils.getDateOfISOWeek(this.selectedWeek, this.selectedYear)
		);

		if (
			(this.facade.dataStorageService.getParam(
				'planningValidationRedirected'
			) as boolean) === true
		) {
			this.selectedWeek = this.facade.dataStorageService.getParam(
				'planningValidationRedirectedWeekNumber'
			);
			this.solution = null;
			this.facade.solutionService
				.getSolutionByYearAndWeekNumber(this.selectedYear, this.selectedWeek)
				.subscribe((sol) => {
					this.redirectedSolution = sol;
					this.nextClick(
						this.dateUtils.getDateOfISOWeek(
							this.selectedWeek,
							this.selectedYear
						)
					);
					this.openValidatePlanningModal();
					this.facade.dataStorageService.setParam(
						'planningValidationRedirected',
						false
					);
				});
		}

		if (this.isMobile) {
			this.displayPlanningForEmployee(this.currentUser.employee);
		}
	}

	ngAfterViewInit(): void {
		if (
			(this.facade.dataStorageService.getParam(
				'planningBuildSolutionRedirected'
			) as boolean) === true
		) {
			this.selectedWeek = this.facade.dataStorageService.getParam(
				'planningBuildSolutionRedirectedWeekNumber'
			);
			this.updateBeginAndEndDates(
				this.dateUtils.getDateOfISOWeek(this.selectedWeek, this.selectedYear)
			);
			this.selectedCalendarDate = this.beginDate;
			this.getDataForPlanning.emit({
				dateToLoad: this.selectedCalendarDate,
				reloadEmployeesAndVacation: false,
				reloadSolution: true,
				reloadOptimInProgress: true
			});
			this.launchBuild.emit();
			this.facade.dataStorageService.setParam(
				'planningBuildSolutionRedirected',
				false
			);
		}
	}

	@HostListener('window:keyup', ['$event'])
	keyEvent(event: KeyboardEvent) {
		if (event.key === 'ArrowLeft') {
			this.prev.nativeElement.click();
		}
		if (event.key === 'ArrowRight') {
			this.next.nativeElement.click();
		}
	}

	selectedCenterChange() {
		this.selectedCenterChangeEvent.emit(this.selectedCenter);
	}

	changeAbsenceSwitch() {
		this.isAbsenceSwitchActive = !this.isAbsenceSwitchActive;
		this.facade.dataStorageService.setParam(
			'storedAbsenceSwitchActive',
			this.isAbsenceSwitchActive
		);
		this.refreshView.emit();
	}

	changeWeekendSwitch() {
		this.isWeekendActive = !this.isWeekendActive;
		this.getDataForPlanning.emit({ changeDisplayWeekend: true });

		this.updateBeginAndEndDates(
			this.dateUtils.getMonday(this.selectedCalendarDate)
		);
	}

	changeScheduledViewAllEmpsSwitch() {
		this.isScheduledViewAllEmpsSwitchActive =
			!this.isScheduledViewAllEmpsSwitchActive;
	}

	changeScheduledViewUnassignedMissionsSwitch() {
		this.isScheduledViewUnassignedMissionsSwitchActive =
			!this.isScheduledViewUnassignedMissionsSwitchActive;
	}

	changeViewMissionSwitch() {
		this.isViewTourneesSwitchActive = !this.isViewTourneesSwitchActive;

		this.facade.dataStorageService.setParam(
			'storedViewMissionSwitchActive',
			this.isViewTourneesSwitchActive
		);

		if (this.ddEmployee === this.defaultText) {
			this.displayAllPlanning();
		} else if (this.selectedEmployeeInDropdown) {
			this.displayPlanningForEmployee(this.selectedEmployeeInDropdown);
		} else if (this.selectedCompetenceInDropdown) {
			this.displayPlanningBySkill(this.selectedCompetenceInDropdown);
		}
	}

	changeAlignedWeekViewSwitch() {
		this.isAlignedWeekViewSwitchActive = !this.isAlignedWeekViewSwitchActive;

		this.isAlignedWeekViewSwitchActive
			? this.setAlignedView.emit('aligned-view')
			: this.setAlignedView.emit('regular-view');

		if (this.isModeAvailabilityActive?.active) {
			if (this.ddEmployee === this.defaultText) {
				this.displayAllPlanningAvailability();
			} else if (this.selectedEmployeeInDropdown) {
				this.displayAvailabilityForEmployee(this.selectedEmployeeInDropdown);
			} else if (this.selectedCompetenceInDropdown) {
				this.displayAvailabilityBySkill(this.selectedCompetenceInDropdown);
			}
		} else {
			if (this.ddEmployee === this.defaultText) {
				this.displayAllPlanning();
			} else if (this.selectedEmployeeInDropdown) {
				this.displayPlanningForEmployee(this.selectedEmployeeInDropdown);
			} else if (this.selectedCompetenceInDropdown) {
				this.displayPlanningBySkill(this.selectedCompetenceInDropdown);
			}
		}
	}

	isNavbarButtonDisplayable() {
		return (
			!this.isMobile &&
			this.isPlanificatrice &&
			this.solution &&
			this.view === CalendarView.Week &&
			!this.isModeListActive?.active &&
			(!this.selectedCenter ||
				this.currentUserCenter.id === this.selectedCenter?.id)
		);
	}

	displayPlanningForEmployee(employee?: Employee) {
		this.ddBeneficiaire = this.defaultText;
		this.selectedCompetenceInDropdown = null;
		this.selectedEmployeeInDropdown = employee;
		this.selectedMissionType = null;
		this.selectedMissionPlace = null;
		this.selectedCenterDepartment = null;
		this.ddCenterDepartment = this.defaultText;
		this.ddFormation = this.defaultText;
		this.ddMissionPlace = this.defaultText;
		this.ddEmployee = `${employee.firstName} ${employee.lastName}`;
		this.refreshView.emit();
	}

	//Affiche les missions du beneficiaire sélectionné sur le planning
	displayPlanningForBeneficiaire(benef?: Beneficiaire) {
		// pas de vue benef si vue tournées
		if (!this.isViewTourneesSwitchActive) {
			return;
		}

		this.ddEmployee = this.defaultText;
		this.selectedEmployeeInDropdown = null;
		this.selectedBeneficiaireInFilter = benef;
		this.selectedMissionType = null;
		this.selectedMissionPlace = null;
		this.selectedCenterDepartment = null;
		this.ddCenterDepartment = this.defaultText;
		this.ddFormation = this.defaultText;
		this.ddMissionPlace = this.defaultText;
		this.ddBeneficiaire = `${benef.firstName} ${benef.lastName}`;

		this.refreshView.emit();
	}

	displayAllPlanning() {
		this.selectedEmployeeInDropdown = null; // c'est soit un employee soit un skill qui est selectionné
		this.selectedCompetenceInDropdown = null; // c'est soit un employee soit un skill qui est selectionné
		this.selectedBeneficiaireInFilter = null;
		this.selectedMissionType = null;
		this.selectedMissionPlace = null;
		this.selectedCenterDepartment = null;
		this.ddFormation = this.defaultText;
		this.ddMissionPlace = this.defaultText;
		this.ddCenterDepartment = this.defaultText;

		this.isAggregationNecessaryForDropdown = true;
		this.ddEmployee = this.defaultText;
		this.ddBeneficiaire = this.defaultText;
		this.refreshView.emit();
	}

	displayPlanningBySkill(competence?: any) {
		this.selectedEmployeeInDropdown = null; // c'est soit un employee soit un skill qui est selectionné
		this.selectedMissionType = null;
		this.selectedMissionPlace = null;
		this.selectedCenterDepartment = null;

		this.ddFormation = this.defaultText;
		this.ddMissionPlace = this.defaultText;
		this.ddCenterDepartment = this.defaultText;
		this.isAggregationNecessaryForDropdown = true;
		this.ddEmployee = competence ? competence.value : this.defaultText;
		this.selectedCompetenceInDropdown = competence;

		this.refreshView.emit();
	}

	displayPlanningByMissionType(type?: MissionType) {
		// pas de vue missionType si vue tournées
		if (!this.isViewTourneesSwitchActive) {
			return;
		}

		this.ddEmployee = this.defaultText;
		this.ddBeneficiaire = this.defaultText;
		this.ddMissionPlace = this.defaultText;
		this.ddCenterDepartment = this.defaultText;

		this.selectedEmployeeInDropdown = null;
		this.selectedMissionPlace = null;
		this.selectedCenterDepartment = null;

		this.ddFormation = `${type.type}`;
		this.selectedMissionType = type;

		this.refreshView.emit();
	}

	displayPlanningByCenterDepartment(centerDepartment?: CenterDepartment) {
		if (!this.isViewTourneesSwitchActive) {
			return;
		}

		this.ddEmployee = this.defaultText;
		this.ddBeneficiaire = this.defaultText;
		this.ddFormation = this.defaultText;
		this.ddMissionPlace = this.defaultText;

		this.selectedEmployeeInDropdown = null;
		this.selectedMissionPlace = null;
		this.selectedMissionType = null;

		this.ddCenterDepartment = `${centerDepartment.name}`;
		this.selectedCenterDepartment = centerDepartment;

		this.refreshView.emit();
	}

	displayPlanningByMissionPlace(missionPlace?: MissionPlace) {
		// pas de vue missionPlace si vue tournées
		if (!this.isViewTourneesSwitchActive) {
			return;
		}

		this.ddEmployee = this.defaultText;
		this.ddBeneficiaire = this.defaultText;
		this.ddFormation = this.defaultText;
		this.ddCenterDepartment = this.defaultText;
		this.selectedCenterDepartment = null;
		this.selectedEmployeeInDropdown = null;
		this.selectedMissionPlace = missionPlace;
		this.ddMissionPlace = `${missionPlace.nameDisplay}`;
		this.refreshView.emit();
	}

	getNbMission(): number {
		return (
			this.solution?.plannings
				.flatMap((planning) => planning.routes)
				.flatMap((route) => route?.missions)?.length +
			this.solution?.unassignedMissions.length
		);
	}

	getNbMissionWithCompetence(competence: CareSkill): number {
		if (this.view === CalendarView.Week || this.view === CalendarView.Day) {
			if (
				this.solution &&
				(this.solution.plannings?.length > 0 ||
					this.solution.unassignedMissions.length > 0)
			) {
				const targetPlannings = this.solution.plannings.filter((planning) =>
					planning.employee?.careSkills?.some((skill) =>
						skill.name.includes(competence.name)
					)
				);

				let nombreReunion = 0;
				targetPlannings.forEach((planning) => {
					nombreReunion += planning.routes
						?.flatMap((route) => route.missions)
						.filter(
							(mission) =>
								mission?.missionRequest.missionType.type ===
								MISSION_TYPE_REUNION_TYPE
						).length;
				});

				let valeurInitiale = 0;
				let somme = targetPlannings.reduce(
					(accumulateur, planningCourant) =>
						accumulateur +
						planningCourant.routes?.flatMap((route) => route.missions).length,
					valeurInitiale
				);

				somme += this.solution.unassignedMissions.filter((mission) =>
					mission?.missionRequest.beneficiaire?.careSkills?.some((skill) =>
						skill.name.includes(competence.name)
					)
				).length;

				somme -= nombreReunion;
				return somme || 0;
			}
		} else if (this.view === CalendarView.Month) {
			if (this.solutions && this.solutions.length > 0) {
				let nbMission = 0;
				for (const solution of this.solutions) {
					const targetPlannings = solution.plannings.filter((planning) =>
						planning.employee?.careSkills?.some((skill) =>
							skill.name.includes(competence.name)
						)
					);

					let valeurInitiale = 0;
					let somme = targetPlannings.reduce(
						(accumulateur, planningCourant) =>
							accumulateur +
							planningCourant.routes.flatMap((route) => route.missions).length,
						valeurInitiale
					);

					somme += solution.unassignedMissions.filter((mission) =>
						mission?.missionRequest.beneficiaire?.careSkills?.some((skill) =>
							skill.name.includes(competence.name)
						)
					).length;

					nbMission += somme;
				}
				return nbMission;
			}
		}
		return 0; // Ajout d'une valeur de retour par défaut pour les autres cas
	}

	getNbMissionOfEmployeePlanning(idEmployee: number): number {
		let nbMission = 0;
		if (this.view === CalendarView.Week || this.view === CalendarView.Day) {
			if (this.solution && this.solution.plannings?.length > 0) {
				const targetPlanning = this.solution.plannings.find(
					(planning) => planning.employee.id === idEmployee
				);
				nbMission = targetPlanning
					? targetPlanning.routes.flatMap((route) => route.missions).length
					: 0;
			}
		} else if (this.view === CalendarView.Month) {
			if (this.solutions && this.solutions.length > 0) {
				for (const solution of this.solutions) {
					const targetPlanning = solution.plannings.find(
						(planning) => planning.employee.id === idEmployee
					);
					nbMission += targetPlanning
						? targetPlanning.routes.flatMap((route) => route.missions).length
						: 0;
				}
			}
		}
		return nbMission;
	}

	validatePlanning() {
		if (this.redirectedSolution) {
			this.facade.solutionService
				.validationSolution(this.redirectedSolution.id)
				.subscribe({
					next: (succ) => {
						this.getDataForPlanning.emit({
							date: this.selectedCalendarDate
						});
						this.updateBeginAndEndDates(
							this.dateUtils.getMonday(this.selectedCalendarDate)
						);

						this.redirectedSolution.validate = true;
						this.solution.validate = true;
						this.cdr.markForCheck();
					},
					error: (err) => {
						this.redirectedSolution.validate = false;
						this.solution.validate = false;
						this.getDataForPlanning.emit({
							dateToLoad: this.selectedCalendarDate,
							reloadEmployeesAndVacation: false,
							reloadSolution: true,
							reloadOptimInProgress: true
						});
					},
					complete: () => {
						this.modalRefVerouillage?.hide();
					}
				});
		} else {
			if (this.solution) {
				this.facade.solutionService
					.validationSolution(this.solution.id)
					.subscribe({
						next: (succ) => {
							this.solution.validate = true;
							this.cdr.markForCheck();
						},
						error: (err) => {
							this.solution.validate = false;
							this.getDataForPlanning.emit({
								dateToLoad: this.selectedCalendarDate,
								reloadEmployeesAndVacation: false,
								reloadSolution: true,
								reloadOptimInProgress: true
							});
						},
						complete: () => {
							this.modalRefVerouillage?.hide();
						}
					});
			}
		}
	}

	invalidatePlanning() {
		if (this.solution) {
			this.facade.solutionService
				.unvalidationSolution(this.solution.id)
				.subscribe({
					next: (succ) => {
						this.solution.validate = false;
						this.cdr.markForCheck();
						this.modalRefDeverouillage?.hide();
					},
					error: (err) => {
						this.solution.validate = false;
						this.getDataForPlanning.emit({
							dateToLoad: this.selectedCalendarDate,
							reloadEmployeesAndVacation: false,
							reloadSolution: true,
							reloadOptimInProgress: true
						});
						this.modalRefDeverouillage?.hide();
					}
				});
		}
	}

	openValidatePlanningModal() {
		this.modalRefVerouillage = this.modalService.show(this.templateVerouillage);
	}

	openSolutionNotes() {
		this.modalRefSolutionNotes = this.modalService.show(
			this.templateSolutionNotes,
			{ class: 'modal-lg' }
		);
	}

	updateSolutionNotes() {
		if (this.solution) {
			this.facade.solutionService
				.updateSolutionNotes(this.solution.id, this.solution.notes)
				.subscribe({
					next: (succ) => {
						this.cdr.markForCheck();
						this.modalRefSolutionNotes?.hide();
					},
					error: (err) => {
						this.modalRefSolutionNotes?.hide();
					}
				});
		}
	}

	openInvalidatePlanningModal(template: TemplateRef<any>) {
		if (this.solution) {
			this.modalRefDeverouillage = this.modalService.show(template);
		}
	}

	nextClick(date: Date) {
		this.logger.log(`nextClick - ${date}`);
		const nextDate = new Date(date);
		if (this.view === CalendarView.Week) {
			this.updateBeginAndEndDates(date);
		}
		this.cleanDateRangeSession();
		this.getDataForPlanning.emit({
			dateToLoad: nextDate,
			reloadEmployeesAndVacation: this.isAbsenceSwitchActive,
			reloadSolution: true,
			reloadOptimInProgress: true
		});
	}

	previousClick(date: Date) {
		this.logger.log(`prevClick - ${date}`);
		const prevDate = new Date(date);
		if (this.view === CalendarView.Week) {
			this.updateBeginAndEndDates(date);
		}
		this.cleanDateRangeSession();
		this.getDataForPlanning.emit({
			dateToLoad: prevDate,
			reloadEmployeesAndVacation: this.isAbsenceSwitchActive,
			reloadSolution: true,
			reloadOptimInProgress: true
		});
	}

	resetDateClick() {
		const date: Date = new Date();
		this.updateBeginAndEndDates(date);
		this.cleanDateRangeSession();
		this.getDataForPlanning.emit({
			dateToLoad: date,
			reloadEmployeesAndVacation: false,
			reloadSolution: true,
			reloadOptimInProgress: true
		});
	}

	updateBeginAndEndDates(date: Date) {
		this.beginDate = this.dateUtils.getMonday(date);
		if (this.isWeekendActive) {
			this.endDate = new Date(this.beginDate);
			this.endDate.setDate(this.endDate.getDate() + 6);
		} else {
			this.endDate = new Date(this.beginDate);
			this.endDate.setDate(this.endDate.getDate() + 4);
		}

		this.facade.dataStorageService.setParam(
			'storedCalendarWeeknumber',
			this.dateUtils.getWeekNumber(this.beginDate)
		);

		this.facade.dataStorageService.setParam(
			'storedCalendarYearnumber',
			this.beginDate.getFullYear()
		);
	}

	cleanDateRangeSession() {
		this.facade.dataStorageService.removeSessionItem('missionStartDate');
		this.facade.dataStorageService.removeSessionItem('missionEndDate');
	}

	activateModeList() {
		this.isModeListActive.active = true;
		this.isModeAvailabilityActive.active = false;
		console.log('modelistActive = ' + this.isModeListActive.active);
		console.log(
			'isModeAvailabilityActive = ' + this.isModeAvailabilityActive.active
		);
	}

	activateModeAvailability() {
		this.isModeListActive.active = false;
		this.isModeAvailabilityActive.active = true;
		this.selectedEmployeeInDropdown =
			this.employeesList.length > 0 ? this.employeesList[0] : null;
		if (this.selectedEmployeeInDropdown) {
			this.ddEmployee = `${this.selectedEmployeeInDropdown.firstName} ${this.selectedEmployeeInDropdown.lastName}`;
		}
		this.refreshView.emit();
	}

	exportAsListPDF(
		solution: Solution,
		selectedWeek: number,
		beginDate: Date,
		endDate: Date
	) {
		let copyOfSolutionForPdfGeneration = new Solution();
		copyOfSolutionForPdfGeneration = solution;
		// on manipule une copie, sinon on modifie le vrai planning (car c'est passé par input)
		if (this.selectedEmployeeInDropdown) {
			this.exportPdfUtils.exportAsListPDF(
				copyOfSolutionForPdfGeneration,
				selectedWeek,
				beginDate,
				endDate,
				this.selectedEmployeeInDropdown.id
			);
		} else if (this.facade.dataStorageService.isIntervenant()) {
			this.exportPdfUtils.exportAsListPDF(
				copyOfSolutionForPdfGeneration,
				selectedWeek,
				beginDate,
				endDate,
				this.currentUser.employee.id
			);
		} else {
			// pas besoin de manipulation, on génère celui de tout le monde
			this.exportPdfUtils.exportAsListPDF(
				copyOfSolutionForPdfGeneration,
				selectedWeek,
				beginDate,
				endDate
			);
		}
	}

	exportAsPDF() {
		this.exportPdfUtils.exportAsPDF('MyDIv', this.ddEmployee);
	}

	openCopyDataModal(): void {
		const closeInterceptor = () => {
			this.confirmPromise = new Promise((resolve, reject) => {
				this.confirmResolve = resolve;
				this.confirmReject = reject;
			});

			if (!this.copyButtonDisabled) {
				if (this.confirmResolve) {
					this.confirmResolve();
				}
			}
			if (!this.copyButtonDisabled) {
				if (this.confirmReject) {
					this.confirmReject();
				}
			}

			return this.confirmPromise;
		};

		this.templateCopyingData = this.modalService.show(this.copyingDataModal, {
			closeInterceptor
		});
	}

	copyPlanning(): void {
		this.copyButtonDisabled = true;
		this.facade.solutionService
			.copySolutionToAnotherWeek(
				this.selectedCalendarDate.getFullYear(),
				this.dateUtils.getWeekNumber(this.selectedCalendarDate),
				this.selectedYearNumberForCopy,
				this.weekNumberSelectedForCopy
			)
			.subscribe({
				next: () => {
					// nécessaire pour éviter "this.templateCopyingData is undefined"
					const root = this;
					setTimeout(function () {
						root.copyButtonDisabled = false;
						root.templateCopyingData.hide();
					}, 1000);
				},
				error: (err) => {
					this.copyButtonDisabled = false;
				}
			});
	}

	downloadFile(): void {
		const filename = `Planning_Semaine_${this.solution.weekNumber}.xlsx`;
		this.facade.exportService
			.exportSolutionAsXlsx(filename, this.solution.id)
			.subscribe((blob) => saveAs(blob, filename));
	}

	changeView(viewType: any) {
		this.updateBeginAndEndDates(this.selectedCalendarDate);
		// if (viewType === CalendarView.Day) {
		// 	// vue jour : reset des filtres du planning
		// 	this.displayAllPlanning();
		// }
		// if (viewType === CalendarView.Week && this.isMobile) {
		// 	this.displayPlanningForEmployee(this.currentUser.employee);
		// }
		this.setView.emit(viewType);
	}

	refreshPlanningFilter() {
		if (this.selectedEmployeeInDropdown) {
			if (!this.isModeAvailabilityActive?.active) {
				this.displayPlanningForEmployee(this.selectedEmployeeInDropdown);
			} else {
				this.displayAvailabilityForEmployee(this.selectedEmployeeInDropdown);
			}
		} else if (this.selectedCompetenceInDropdown) {
			if (!this.isModeAvailabilityActive?.active) {
				this.displayPlanningBySkill(this.selectedCompetenceInDropdown);
			} else {
				this.displayAvailabilityBySkill(this.selectedCompetenceInDropdown);
			}
		}

		if (this.selectedBeneficiaireInFilter) {
			if (!this.isModeAvailabilityActive?.active) {
				this.displayPlanningForBeneficiaire(this.selectedBeneficiaireInFilter);
			} else {
				this.selectedBeneficiaireInFilter = null;
			}
		}
	}

	openOptimizationReport(template: any) {
		this.modalRefOptimizationReport = this.modalService.show(template, {
			class: 'modal-xl'
		});
	}

	getTemporaryOptimReports() {
		if (this.solution) {
			this.facade.solutionService
				.getTemporaryOptimizationReports(this.solution.id)
				.subscribe({
					next: (mOptimReports: MOptimReport[]) => {
						this.tmpOptimReports = mOptimReports;

						if (mOptimReports.length > 0) {
							this.launchBuild.emit(true);
							this.setMaxFinalValuesOfTmpOptimReports();

							this.modalRefTmpOptimReports = this.modalService.show(
								this.tmpOptimReportsModal,
								{
									class: 'modal-xl'
								}
							);
						} else {
							this.launchBuild.emit();
						}
					},
					error: (err: ErrorResponse) => {
						this.facade.toastService.createInfoToast(err.error.response);
						this.launchBuild.emit();
					}
				});
		} else {
			this.launchBuild.emit();
		}
	}

	setMaxFinalValuesOfTmpOptimReports() {
		Object.keys(this.reportLabelEnum).forEach((reportLabel) => {
			const criteriaReports = this.tmpOptimReports.flatMap((tmpOptimReport) =>
				tmpOptimReport.report.criteriaReports.filter(
					(criteriaReport) => criteriaReport.label === reportLabel
				)
			);
			const finalValues = criteriaReports.map((criteriaReport) => {
				const finalValue = criteriaReport.finalValue;
				const finalValueConverted =
					finalValue.includes('h') || finalValue.includes('m')
						? this.dateUtils.convertStringHoursMinToNumber(finalValue)
						: parseFloat(finalValue);
				return finalValueConverted;
			});

			let extremum = 0;

			if (
				this.reportLabelEnum[reportLabel] ===
					this.reportLabelEnum.NB_SPECIALTIES_UNSATISFIED ||
				this.reportLabelEnum[reportLabel] ===
					this.reportLabelEnum.NB_PREFERENCES_RESPECTED ||
				this.reportLabelEnum[reportLabel] ===
					this.reportLabelEnum.NB_MISSIONS_UNASSIGNED
			) {
				extremum = Math.max(...finalValues);
			} else {
				extremum = Math.min(...finalValues);
			}

			// Maintenant qu'on a l'extremum, on retrouve le tmpOptimReport.report.criteriaReport correspondant pour passer le boolean bestValue à true
			const reportIndexes = finalValues.flatMap((value, i) =>
				value === extremum ? i : []
			);
			reportIndexes.forEach((reportIndex) => {
				const report = this.tmpOptimReports[reportIndex].report;

				if (
					report.criteriaReports.findIndex(
						(critReport) => critReport.label === reportLabel
					) !== -1
				) {
					report.criteriaReports.find(
						(critReport) => critReport.label === reportLabel
					).bestValue = true;
				}
			});
		});
	}

	/*
	 * Affichage des infos dans le tableau de rapport d'optim
	 */
	displayAdditionalInfo(): void {
		this.isDisplayMoreInfoButtonClicked = !this.isDisplayMoreInfoButtonClicked;
		if (this.isDisplayMoreInfoButtonClicked) {
			// Si on veut voir plus d'info, alors on affiche les infos importantes + les infos additionnelles (définit dans le back)
			this.displayAdditionalInfoButtonLabel =
				this.displayAdditionalInfoButtonLabelActive;
			if (this.optimReport) {
				this.displayedCriteriaReport = this.optimReport.criteriaReports.filter(
					(criteriaReport) => {
						return (
							criteriaReport.weight >= 1 ||
							(criteriaReport.weight === 0 && criteriaReport.gain > 0)
						);
					}
				);
			}
		} else {
			// sinon on affiche uniquement les plus importantes
			this.displayAdditionalInfoButtonLabel =
				this.displayAdditionalInfoButtonLabelInactive;
			if (this.optimReport) {
				this.displayedCriteriaReport = this.optimReport.criteriaReports.filter(
					(criteriaReport) => {
						return criteriaReport.weight >= 1;
					}
				);
			}
		}
	}

	openPlanifModal() {
		if (this.facade.dataStorageService.isOptimMultipleActive()) {
			this.getTemporaryOptimReports();
		} else {
			this.launchBuild.emit();
		}
	}

	displayAllPlanningAvailability() {
		this.selectedEmployeeInDropdown = null; // c'est soit un employee soit un skill qui est selectionné
		this.selectedCompetenceInDropdown = null; // c'est soit un employee soit un skill qui est selectionné
		this.selectedBeneficiaireInFilter = null;
		this.isAggregationNecessaryForDropdown = true;
		this.ddEmployee = this.defaultText;
		this.ddBeneficiaire = this.defaultText;
		this.refreshView.emit();
	}

	displayAvailabilityBySkill(skill: any) {
		this.selectedEmployeeInDropdown = null; // c'est soit un employee soit un skill qui est selectionné
		this.selectedCompetenceInDropdown = skill;
		this.isAggregationNecessaryForDropdown = true;
		this.ddEmployee = skill ? skill.value : this.defaultText;
		this.refreshView.emit();
	}

	getNbAvailabilityWithCompetence(skill: any) {
		const targetPlanning = this.eventAvailabilitySaved.filter((event) =>
			event.meta?.employee?.careSkill?.name.includes(skill.key)
		);
		return targetPlanning.length !== 0 ? targetPlanning.length - 1 : 0;
	}

	displayAvailabilityForEmployee(employee: any) {
		this.ddBeneficiaire = this.defaultText;
		this.selectedCompetenceInDropdown = null;
		this.selectedEmployeeInDropdown = employee;
		this.ddEmployee = `${employee.firstName} ${employee.lastName}`;
		this.refreshView.emit();
	}

	getNbAvailabilityOfEmployee(idEmployee: any) {
		const targetPlanning = this.eventAvailabilitySaved.filter(
			(event) => event.meta?.employee?.id === idEmployee
		);
		return targetPlanning.length !== 0 ? targetPlanning.length - 1 : 0;
	}

	/**
	 * Téléchargement du planning d'un employé sous format CSV (pour import sur Google Agenda/Outlook)
	 * @param employeeId : l'id de l'employé dont on veut le planning sous format CSV
	 */
	exportAgendaCsv() {
		const employeeId = this.currentUser.employee.id;
		const planning = this.solution.plannings?.find(
			(plan) => plan.employee.id === employeeId
		);
		if (planning) {
			this.facade.exportService
				.exportCalendarAsCsv(this.solution.id, planning.id)
				.subscribe((blob) =>
					saveAs(
						blob,
						`agenda_${planning.employee.firstName}_${planning.employee.lastName}.csv`
					)
				);
		} else {
			this.facade.toastService.createWarningToast(
				"Vous n'avez pas de mission cette semaine !"
			);
		}
	}

	/**
	 * Téléchargement du planning d'un employé sous format iCalendar (pour import sur Google Agenda/Outlook)
	 * @param employeeId : l'id de l'employé dont on veut le planning sous format CSV
	 */
	exportAgendaICal() {
		const employeeId = this.currentUser.employee.id;
		const planning = this.solution.plannings?.find(
			(plan) => plan.employee.id === employeeId
		);
		if (planning) {
			this.facade.exportService
				.exportAgendaAsICalendar(this.solution.id, planning.id)
				.subscribe((blob) =>
					saveAs(
						blob,
						`agenda_${planning.employee.firstName}_${planning.employee.lastName}.ics`
					)
				);
		} else {
			this.facade.toastService.createWarningToast(
				"Vous n'avez pas de mission cette semaine !"
			);
		}
	}

	openExportCalendarModal(): void {
		this.modalRefExportCalendar = this.modalService.show(
			this.templateExportCalendarModal,
			{
				class: 'modal-lg'
			}
		);
	}

	/**
	 * Si on peut afficher le bouton "Planifier"
	 * @returns un booléen indiquant si l'élement HTML est affichable ou non
	 */
	isDisplayablePlanifierButton(): boolean {
		return (
			this.isPlanificatrice &&
			!this.isMobile &&
			this.solution &&
			!this.solution.validate &&
			this.view === CalendarView.Week &&
			(!this.selectedCenter ||
				this.currentUserCenter.id === this.selectedCenter?.id)
		);
	}

	/* Si on peut afficher le bouton "Rapport"
	 * @returns un booléen indiquant si l'élement HTML est affichable ou non
	 */
	isDisplayableReportAndCoordinationButtons(): boolean {
		return (
			!this.isMobile &&
			this.isPlanificatrice &&
			this.solution &&
			this.view === CalendarView.Week &&
			(!this.selectedCenter ||
				this.currentUserCenter.id === this.selectedCenter?.id)
		);
	}

	/* Si on peut afficher le bouton "Valider"
	 * @returns un booléen indiquant si l'élement HTML est affichable ou non
	 */
	isDisplayableValidateButton(): boolean {
		return (
			!this.isMobile &&
			this.isPlanificatrice &&
			this.solution &&
			!this.solution.validate &&
			this.view === CalendarView.Week &&
			(!this.selectedCenter ||
				this.currentUserCenter.id === this.selectedCenter?.id)
		);
	}

	/* Si on peut afficher le bouton "Déverrouiller"
	 * @returns un booléen indiquant si l'élement HTML est affichable ou non
	 */
	isDisplayableUnlockButton(): boolean {
		return (
			!this.isMobile &&
			this.isPlanificatrice &&
			this.solution &&
			this.solution.validate &&
			this.view === CalendarView.Week &&
			(!this.selectedCenter ||
				this.currentUserCenter.id === this.selectedCenter?.id)
		);
	}

	/* Si on peut afficher le dropdown "Télécharger"
	 * @returns un booléen indiquant si l'élement HTML est affichable ou non
	 */
	isDisplayableDownloadDropdownButton(): boolean {
		return !this.isMobile && this.solution && this.view === CalendarView.Week;
	}

	/* Si on peut cliquer sur le bouton de téléchargement (ou s'il est grisé)
	 * @returns un booléen indiquant si l'élement HTML est cliquable ou non
	 */
	isClickableDownloadDropdownButton(): boolean {
		const isClickable =
			this.isDisplayableExportAsListButtonInDropdown() ||
			this.isDisplayableExportButtonInDropdown() ||
			this.isDisplayableGoogleOutlookExportButton();
		return isClickable;
	}

	/* Si on peut afficher les boutons d'export en format liste
	 * @returns un booléen indiquant si l'élement HTML est affichable ou non
	 */
	isDisplayableExportAsListButtonInDropdown(): boolean {
		if (this.facade.dataStorageService.isIntervenant()) {
			return (
				this.solution.plannings.findIndex((planning) => {
					return planning.employee.id === this.currentUser.employee.id;
				}) !== -1
			);
		} else {
			return this.solution.plannings.length > 0 ? true : false;
		}
	}

	/* Si on peut afficher les boutons d'exports du dropdown "Télécharger"
	 * @returns un booléen indiquant si l'élement HTML est affichable ou non
	 */
	isDisplayableExportButtonInDropdown(): boolean {
		return this.isPlanificatrice && this.solution.plannings.length > 0;
	}

	/* Si on peut afficher le bouton d'export Google/Outlook
	 * @returns un booléen indiquant si l'élement HTML est affichable ou non
	 */
	isDisplayableGoogleOutlookExportButton(): boolean {
		return true; // toujours possible, on doit avoir accès à l'URL de souscription pour Google Agenda, Outlook etc.
	}

	/* Si on peut afficher le bouton d'export Google/Outlook
	 * @returns un booléen indiquant si l'élement HTML est affichable ou non
	 */
	isDisplayableCopyButton(): boolean {
		return (
			this.isPlanificatrice &&
			!this.isMobile &&
			this.solution &&
			this.view === CalendarView.Week &&
			this.currentUserCenter.id === this.selectedCenter?.id
		);
	}

	/* Si on peut afficher le loader circulaire
	 * @returns un booléen indiquant si l'élement HTML est affichable ou non
	 */
	isDisplayableLoader(): boolean {
		return this.isLoadingSolution && !this.isMobile;
	}

	/* Si on peut afficher la zone des boutons de zoom (contenant tous les boutons)
	 * @returns un booléen indiquant si l'élement HTML est affichable ou non
	 */
	isDisplayableZoomButtonsZone(): boolean {
		return (
			(this.view === CalendarView.Week || this.view === CalendarView.Day) &&
			!this.isModeListActive?.active
		);
	}

	/* Si on peut afficher la zone des boutons de sélection de vue (contenant tous les boutons)
	 * @returns un booléen indiquant si l'élement HTML est affichable ou non
	 */
	isDisplayableViewTypeButtonZone(): boolean {
		return !this.isMobile;
	}

	/* Si on peut afficher le contrôleur de semaine (vue mobile)
	 * @returns un booléen indiquant si l'élement HTML est affichable ou non
	 */
	isDisplayableWeekSelectorMobile(): boolean {
		return (
			(this.view === CalendarView.Day || this.view === CalendarView.Week) &&
			this.isMobile
		);
	}

	/* Si on peut afficher le contrôleur de semaine (vue day)
	 * @returns un booléen indiquant si l'élement HTML est affichable ou non
	 */
	isDisplayableWeekSelectorInViewDay(): boolean {
		return this.view === CalendarView.Day && !this.isMobile;
	}

	/* Si on peut afficher le contrôleur de semaine (vue week)
	 * @returns un booléen indiquant si l'élement HTML est affichable ou non
	 */
	isDisplayableWeekSelectorInViewWeek(): boolean {
		return this.view === CalendarView.Week;
	}

	/* Si on peut afficher le contrôleur de semaine (vue month)
	 * @returns un booléen indiquant si l'élement HTML est affichable ou non
	 */
	isDisplayableWeekSelectorInViewMonth(): boolean {
		return this.view === CalendarView.Month;
	}

	/* Si on peut afficher le sélecteur de centre
	 * @returns un booléen indiquant si l'élement HTML est affichable ou non
	 */
	isDisplayableCenterSelectorDropdown(): boolean {
		return this.listViewableCenters && this.selectedCenter ? true : false;
	}

	/* Si on peut afficher la zone où se trouvent les sélecteurs de paramètres d'affichage et les filtres
	 * @returns un booléen indiquant si l'élement HTML est affichable ou non
	 */
	isDisplayableParametersAndFilterButtonZone(): boolean {
		return !this.isModeListActive?.active;
	}

	/* Si on peut afficher le switch vue alignée
	 * @returns un booléen indiquant si l'élement HTML est affichable ou non
	 */
	isDisplayableAlignedViewSwitch(): boolean {
		return !this.isModeListActive?.active && this.view !== CalendarView.Day;
	}

	/* Si on peut afficher le switch pour afficher les congés
	 * @returns un booléen indiquant si l'élement HTML est affichable ou non
	 */
	isDisplayableVacationSwitch(): boolean {
		return (
			!this.isModeListActive?.active && !this.isModeAvailabilityActive?.active
		);
	}

	/* Si on peut afficher le switch pour afficher les week-ends
	 * @returns un booléen indiquant si l'élement HTML est affichable ou non
	 */
	isDisplayableWeekEndSwitch(): boolean {
		return (
			!this.isModeListActive?.active &&
			this.view !== CalendarView.Day &&
			!this.isAlignedWeekViewSwitchActive
		);
	}

	/* Si on peut afficher le switch pour afficher les week-ends
	 * @returns un booléen indiquant si l'élement HTML est affichable ou non
	 */
	isDisplayableAllEmployeesSwitch(): boolean {
		return (
			!this.isModeListActive?.active &&
			this.view === CalendarView.Day &&
			!this.isMobile
		);
	}

	/* Si on peut afficher le switch pour afficher les missions non assignées
	 * @returns un booléen indiquant si l'élement HTML est affichable ou non
	 */
	isDisplayableUnassignedMissionSwitch(): boolean {
		return (
			!this.isModeListActive?.active &&
			this.view === CalendarView.Day &&
			this.currentUserAuthority !== Authority.INTERVENANT
		);
	}

	/* Si on peut afficher le switch pour afficher l'input de recherche par intervenant
	 * @returns un booléen indiquant si l'élement HTML est affichable ou non
	 */
	isDisplayableIntervenantFilter(): boolean {
		return (
			this.employeesList &&
			!this.isModeListActive?.active &&
			!this.isModeAvailabilityActive?.active &&
			this.view !== CalendarView.Day
		);
	}

	/* Si on peut afficher le switch pour afficher l'input de recherche par intervenant (vue disponibilité)
	 * @returns un booléen indiquant si l'élement HTML est affichable ou non
	 */
	isDisplayableEmployeeFilterAvailabilityView(): boolean {
		return (
			this.employeesList &&
			!this.isModeListActive?.active &&
			this.isModeAvailabilityActive?.active
		);
	}

	/* Si on peut afficher le switch pour afficher l'input de recherche par intervenant
	 * @returns un booléen indiquant si l'élement HTML est affichable ou non
	 */
	isDisplayableBeneficiaireFilterDropdown(): boolean {
		return (
			!this.isModeListActive?.active && !this.isModeAvailabilityActive?.active
		);
	}

	/* Si on peut afficher le switch pour afficher l'input de recherche par intervenant
	 * @returns un booléen indiquant si l'élement HTML est affichable ou non
	 */
	isDisplayableMissionTypeDropdown(): boolean {
		return (
			!this.isModeListActive?.active && !this.isModeAvailabilityActive?.active
		);
	}

	isDisplayableCenterDepartmentDropdown(): boolean {
		return (
			!this.isModeListActive?.active && !this.isModeAvailabilityActive?.active
		);
	}

	/**
	 * Si on peut afficher le dropdown de filtre par missionPlace
	 * @returns booléen indiquant si l'élement est affichable ou non
	 */
	isDisplayableMissionPlaceDropdown(): boolean {
		return (
			!this.isModeListActive?.active &&
			!this.isModeAvailabilityActive?.active &&
			this.isSESSAD
		);
	}

	/* Si on peut afficher le switch pour afficher l'input de recherche par intervenant
	 * @returns un booléen indiquant si l'élement HTML est affichable ou non
	 */
	isDisplayableLoaderForMobile(): boolean {
		return this.isLoadingSolution && this.isMobile;
	}

	isDisplayableAddDropdownButton(): boolean {
		const isSelectedCenterSameAsUser = this.selectedCenter
			? this.selectedCenter.id === this.currentUser.employee.serviceCenter.id
			: true;
		return !this.isIntervenant && isSelectedCenterSameAsUser;
	}

	openModalCreateVacation() {
		this.openCreateVacationModaleEmitter.emit();
	}
}
